import React, { useContext, useEffect, useState } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import {
  Form,
  Input,
  InputNumber,
  Select,
  Checkbox,
  Upload,
  Button,
  Spin,
  Typography,
  message,
  Row,
  Col
} from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { updateProduct, upload } from '../services/request'
import Header from '../components/Header'
import AppContext from '../context/Context'
import PageError from '../components/PageError'
import MoneyInput from '../components/MoneyInput'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { api } from '../services/api'

const { TextArea } = Input
const { Title } = Typography

function CreateProducts () {
  const [features, setFeatures] = useState([])
  const [form] = Form.useForm()
  const history = useHistory()

  const { loading, setLoading, error, setError, editMode, product } =
    useContext(AppContext)

  const [fotos, setFotos] = useState([])
  const host = process.env.REACT_APP_API_URL

  const MAX_DESCRICAO_LENGTH = 100

  const quillModules = {
    toolbar: [
      [{ font: [] }],
      [{ size: ['small', false, 'large', 'huge'] }],

      [{ align: [] }],

      ['bold', 'italic', 'underline', 'strike'],

      [{ color: [] }, { background: [] }],

      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],

      ['link'],

      ['clean']
    ]
  }

  const handleSubmit = async (values) => {
    try {
      setLoading(true)
      console.log(values, 'values')
      const payload = {
        valor: values.valor,
        descricao: values.descricao,
        descricaoCompleta: values.descricaoCompleta,
        tipo: values.tipo,
        local: values.local,
        modalidade: values.modalidade,
        dormitorios: values.dormitorios,
        au: `${values.au}m²`,
        garagem: values.garagem,
        destaque: values.destaque,
        featureIds: values.features || []
      }

      if (editMode) {
        await updateProduct({ id: product.id }, payload, host)
        message.success('Produto atualizado com sucesso!')
      } else {
        await upload({ ...payload, fotos }, host)
        message.success('Produto criado com sucesso!')
        form.resetFields()
        setFotos([])
      }
    } catch (err) {
      console.error(err)
      setError(true)
      message.error('Ocorreu um erro. Tente novamente.')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const getProductsData = async () => {
      try {
        setLoading(true)
        const response = await api.get('/products/create')
        setFeatures(response.data.features || [])
        console.log('Features carregadas:', response.data.features)
        console.log(features)
      } catch (err) {
        console.error('Erro ao buscar produto:', err)
        setError(true)
      } finally {
        setLoading(false)
      }
    }
    getProductsData()
  }, [])

  useEffect(() => {
    if (editMode && product) {
      form.setFieldsValue({
        valor: product.valor,
        descricao: product.descricao,
        descricaoCompleta: product.descricaoCompleta,
        tipo: product.tipo,
        local: product.local,
        modalidade: product.modalidade,
        dormitorios: product.dormitorios,
        au: Number(product.au.replace('m²', '')),
        garagem: product.garagem,
        destaque: product.destaque
      })
      setFotos(product.fotos || [])
    }
  }, [editMode, product, form])

  const handleUpload = ({ fileList }) => {
    setFotos(fileList.map((file) => file.originFileObj))
  }

  return (
    <>
      {loading
        ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh'
            }}
          >
            <Spin tip="Carregando..." size="large" />
          </div>
        )
        : (
          <>
            <Header />
            {error && <PageError />}
            <div
              style={{
                maxWidth: '800px',
                margin: '20px auto',
                padding: '24px',
                background: '#fff',
                borderRadius: 8,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                overflowY: 'auto'
              }}
            >
              <Title level={3} style={{ marginBottom: 20 }}>
                {editMode ? 'Editar Produto' : 'Adicionar Anúncio'}
              </Title>

              <Form form={form} layout="vertical" onFinish={handleSubmit}>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={24} md={24}>
                    <Form.Item
                      label="Resumo do imóvel"
                      name="descricao"
                      rules={[
                        { required: true, message: 'Resumo é obrigatório!' }
                      ]}
                    >
                      <TextArea
                        maxLength={MAX_DESCRICAO_LENGTH}
                        showCount
                        placeholder="Ex: Casa aconchegante próxima à praia"
                        autoSize={{ minRows: 3, maxRows: 5 }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={24} md={24}>
                    <Form.Item
                      label="Descrição completa"
                      name="descricaoCompleta"
                      rules={[
                        { required: true, message: 'Descrição completa é obrigatória!' }
                      ]}
                      valuePropName="value"
                      getValueFromEvent={(content) => content}
                    >
                      <ReactQuill
                        theme="snow"
                        modules={quillModules}
                        placeholder="Detalhes completos do imóvel"
                        style={{ height: 200, marginBottom: 40 }}
                      />
                    </Form.Item>

                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item label="Tipo" name="tipo" initialValue="casa">
                      <Select>
                        <Select.Option value="casa">Casa</Select.Option>
                        <Select.Option value="galpao">Galpão</Select.Option>
                        <Select.Option value="loja">Loja</Select.Option>
                        <Select.Option value="terreno">Terreno</Select.Option>
                        <Select.Option value="apartamento">
                        Apartamento
                        </Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label="Modalidade"
                      name="modalidade"
                      initialValue="aluguel"
                    >
                      <Select>
                        <Select.Option value="aluguel">Aluguel</Select.Option>
                        <Select.Option value="venda">Venda</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      label="Local"
                      name="local"
                      rules={[
                        { required: true, message: 'Local é obrigatorio!' }
                      ]}
                    >
                      <Input placeholder="Informe a localização" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      label="Dormitórios"
                      name="dormitorios"
                      rules={[
                        { required: true, message: 'Dormitórios é obrigatorio!' }
                      ]}
                    >
                      <InputNumber min={0} style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      label="Área útil (m²)"
                      name="au"
                      rules={[
                        { required: true, message: 'A área útil é obrigatoria!' }
                      ]}
                    >
                      <InputNumber min={0} style={{ width: '100%' }} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item label="Garagem" name="garagem">
                      <InputNumber
                        min={0}
                        style={{ width: '100%' }}
                        placeholder="Número de vagas"
                        defaultValue={0}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={6}>
                    <Form.Item
                      label="Valor"
                      name="valor"
                      rules={[{ required: true, message: 'Informe o valor!' }]}
                    >
                      <MoneyInput />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={24} md={24}>
                    <Form.Item
                      label="Características do imóvel"
                      name="features"
                    >
                      <Select
                        mode="multiple"
                        allowClear
                        placeholder="Selecione as características"
                        options={features}
                        optionFilterProp="label"
                        showSearch
                      />
                    </Form.Item>
                  </Col>

                </Row>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item name="destaque" valuePropName="checked">
                      <Checkbox>Destacar anúncio</Checkbox>
                    </Form.Item>
                  </Col>
                  {!editMode && (
                    <Form.Item label="Imagens">
                      <Upload
                        multiple
                        listType="picture"
                        beforeUpload={() => false} // impede upload automático
                        maxCount={15}
                        onChange={handleUpload}
                      >
                        <Button icon={<UploadOutlined />}>
                        Selecionar Imagens (Max: 15)
                        </Button>
                      </Upload>
                    </Form.Item>
                  )}
                </Row>
                <Form.Item>
                  <Row gutter={[8, 8]}>
                    <Col span={12}>
                      <Button
                        type="default"
                        block
                        onClick={() => {
                          history.push('/home')
                          form.resetFields()
                        }}
                      >
                      Cancelar
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button type="primary" htmlType="submit" block>
                        {editMode ? 'Salvar alterações' : 'Criar Produto'}
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </Form>
            </div>
          </>
        )}
    </>
  )
}

export default CreateProducts
